import styled from '@emotion/styled';
import { flex } from '@/common/styles';

export const Root = styled.div`
  ${flex({ wrap: 'nowrap' })}
  flex: 1;
  background-color: ${({ theme }) => theme.palette.background.base};
`;
